<template lang='pug'>
  include ./../../mixins
  div
    validation-observer(
      tag="form"
      ref="observer"
      v-slot="props"
      @submit.prevent="validateBeforeSubmit"
    )
      +b.g-row.margin_bottom_lg
        +b.g-cell.g-cols--12.--narrow-md
          validation-provider.position_relative(
            tag="div"
            v-slot="{errors}"
            :rules="{ required: { allowFalse: false } }"
            name="value"
          )
            input(
              v-model="value"
              v-show="false"
              name='value'
            )
            +b.error-text--picker.SPAN {{ errors[0] }}
            date-picker.cursor-pointer(
              v-model="value"
              valueType="format"
              format='DD.MM.YYYY'
             )
        +b.g-cell.g-cols--12.--narrow-md.margin_top_md-till-md
          +b.button--color_blue.--width_full.--width_md-lg.fs_md.BUTTON(
            @click.prevent="validateBeforeSubmit"
            :disabled='clicked'
            type='submit'
          ) {{_('Generate Daily Password')}}
    result-table(
      v-if='codes.length > 0'
      :code="codes"
      :data='dates'
    )
    

</template>

<script>
  import FormMixin, { defaultValidatorErrorsParser } from './../../mixins/form-mixin'
  import DatePicker from 'vue2-datepicker'
  import { generatorResource } from '@services/password-generator'
  const today = new Date()
  // today.setHours(0, 0, 0, 0);
  export default {
    components: { DatePicker },
    mixins: [ FormMixin ],
    data() {
      return {
        clicked: false,
        value: null,
        formdata: {},
        codes: [],
        dates: []
      }
    },

    methods: {
      humanData(el) {
        let zero = 0
        let ten = 10
        let date = el.substr(zero, ten)
        const [year, month, day] = date.split('.')
        return el = [day, month, year].join('-')
      },

      send(data) {
        this.formdata['date'] = this.humanData(this.value)
        return generatorResource.execute({}, data)
          .then((res) => {

            this.codes.push(res.gen_code)
            this.dates.push(this.value)
            this.value = ''
            this.$refs.observer.reset()
          })
      },

      async validateBeforeSubmit() {
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.submit(isValid)
        } else {
          return
        }
      },
      updateValidator(errors) {
        const parsed = defaultValidatorErrorsParser(errors)
        this.$refs.observer.setErrors(parsed)
      },

      notBeforeToday(date) {
        return date < today
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/PasswordGenerator/DateForm.vue